import type { AssigneeModel } from '@bliks-io/contracts';

export interface AssigneeFieldVisibility {
  /** "I use" helpers (systems / colleagues / documents). */
  helpers: boolean;
  /** "Who else does this" alternative performers. */
  whoElse: boolean;
}

/**
 * Which assignee-dependent sections a step card should show. Systems don't use
 * helpers or have alternative performers; external contacts may use helpers but
 * the "who else" concept doesn't apply to non-user actors. Shared by the
 * recording flow nodes and the editor step-detail panels so both stay in sync.
 */
export function assigneeFieldVisibility(model?: AssigneeModel): AssigneeFieldVisibility {
  if (model === 'System') return { helpers: false, whoElse: false };
  if (model === 'ExternalContact') return { helpers: true, whoElse: false };
  return { helpers: true, whoElse: true };
}
